import React, { Component } from "react";
import { Translate as T, I18n } from "react-redux-i18n";
import ReactGA from "react-ga";
import Overlay from "../Overlay/Overlay";
import Dialog from "../Dialog/Dialog";

import styles from "./Secret.css";

export default class Secret extends Component {
  state = {
    secret: ""
  };

  componentDidMount = () => this.setSecretFromProps();
  componentWillReceiveProps = () => this.setSecretFromProps();

  render = () => (
    <Overlay show={this.props.show}>
      <form className={styles.secret} onSubmit={this.handleSubmit}>
        <Dialog
          onClose={this.props.hideSecret}
          heading={I18n.t("secret.heading")}
        >
          <div className={styles.wrapper}>
            <input
              type="text"
              placeholder={I18n.t("secret.placeholder")}
              value={this.state.secret}
              onChange={this.handleChange}
              className={styles.input}
              autoFocus
            />
            <button type="submit" className={styles.submit}>
              <T value="secret.submit" />
            </button>
          </div>
        </Dialog>
      </form>
    </Overlay>
  );

  handleChange = e =>
    this.setState({ secret: e.target.value.toUpperCase().slice(0, 25) });

  handleSubmit = e => {
    e.preventDefault();

    this.props.setSecret(this.state.secret);
    this.props.hideSecret();

    ReactGA.event({
      category: "Tools",
      action: "Secret Words"
    });
  };

  setSecretFromProps = () => this.setState({ secret: this.props.secret });
}



// WEBPACK FOOTER //
// ./src/components/Secret/Secret.js